import { Outlet } from "react-router-dom";

export default function WorkflowLayout() {
  return <Outlet />;
}
